import React from "react";
import { Link } from "react-router-dom";
import { Star, Heart, Eye, ShoppingCart } from "lucide-react";

const ProductCard = ({ product }) => {
  return (
    <div className="group bg-white border border-zinc-200 rounded-lg overflow-hidden hover:shadow-xl hover:shadow-zinc-200/60 transition-all duration-300">
      <Link to={`/product/${product.slug}`} className="block relative aspect-square bg-zinc-50 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {product.rating >= 4.8 && (
            <span className="bg-rose-500 text-white text-[10px] uppercase font-bold tracking-wider px-2 py-1 rounded">Best Seller</span>
          )}
        </div>
        <div className="absolute right-3 top-3 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-x-2 group-hover:translate-x-0">
          <button className="w-9 h-9 bg-white rounded-full shadow hover:bg-rose-500 hover:text-white flex items-center justify-center transition-colors" aria-label="Wishlist">
            <Heart className="w-4 h-4" />
          </button>
          <button className="w-9 h-9 bg-white rounded-full shadow hover:bg-rose-500 hover:text-white flex items-center justify-center transition-colors" aria-label="Quick view">
            <Eye className="w-4 h-4" />
          </button>
        </div>
      </Link>
      <div className="p-4">
        <div className="flex items-center gap-1 mb-1.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className={`w-3 h-3 ${i < Math.round(product.rating) ? "fill-amber-400 text-amber-400" : "text-zinc-200"}`} />
          ))}
          <span className="text-[11px] text-zinc-500 ml-1">({product.reviews})</span>
        </div>
        <Link to={`/product/${product.slug}`} className="block text-sm font-semibold text-zinc-900 hover:text-rose-500 transition-colors leading-snug">
          {product.name}
        </Link>
        <div className="flex items-center justify-between mt-3">
          <span className="text-rose-500 font-bold">From ${product.fromPrice}</span>
          <Link to={`/product/${product.slug}`} className="text-xs font-medium text-zinc-600 hover:text-rose-500 flex items-center gap-1 transition-colors">
            <ShoppingCart className="w-3.5 h-3.5" /> Configure
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
